<template>
    <div class="buddycomcall-record-list-root">
        <div id="record-list-field" v-if="!showDetail" class="buddycomcall-record-list-panel">
            <div v-if="!displayInitialNotice" class="object-titlebox">
                 <div class="object-titlebox-right" style="padding-top:10px;padding-bottom:10px">
                    <!-- 更新ボタン -->
                    <button class="transparent-button" type="button" v-on:click="refreshList()">
                        <img src="../../assets/icon_load.svg"/>
                        <span class="normal-command-text" v-t="'message.action_talk_refresh'"></span>
                    </button>
                </div>
            </div>
            <div class="buddycomcall-table-wrap">
                <el-table ref="talkRecordsTable"
                      v-loading="loading" element-loading-text="Loading..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
                      :empty-text="getEmptyTalkRecordText()"
                      :show-header="!displayInitialNotice"
                      :row-class-name="checkHiddenData"
                      :data="talkrecords"
                      :default-sort="{prop: 'activateTime', order: 'ascending'}"
                      :highlight-current-row="true"
                      @row-click="onRowClick"
                      height="100%"
                      style="width: 100%"
                      header-row-class-name="talkrecord-header">

                <!-- prop="activateTime" とは、talkrecords の要素を使うという意味 -->
                <!-- 開始時刻 -->
                <el-table-column prop="activateTime" :label="$t('message.item_talk_start_datetime')" sortable min-width="200">
                    <template slot-scope="scope">
                        {{getStartDate(scope.row) ? getStartDate(scope.row).toLocaleString(): '－'}}
                    </template>
                </el-table-column>

                <!-- 発話者  -->
                <el-table-column :label="$t('message.item_talk_call_talker')" prop="requesterDisplayName" sortable :sort-method="sortByDisplayName" header-align=left align=left min-width="200">
                    <template slot-scope="scope">
                        <span v-if="getDisplayName(scope.row)">
                            <span v-if="getDisplayName(scope.row).length <= 8">{{ getDisplayName(scope.row) }}</span>
                            <span v-else>{{ getDisplayName(scope.row).substring(0, 50) }}...</span>
                        </span>
                    </template>
                </el-table-column>

                <!-- 通話時間  -->
                <el-table-column :label="$t('message.item_talk_time')" prop="endTime" header-align=left align=left min-width="100">
                    <template slot-scope="scope">
                        <span v-if="getDurationMs(scope.row) != null">
                        {{ convertMillsec(getDurationMs(scope.row)) }}
                        </span>
                        <span v-else>－</span>
                    </template>
                </el-table-column>

                <!-- 詳細  -->
                <el-table-column :label="$t('message.action_talk_detail')" header-align=center align=center min-width="100">
                    <template slot-scope="scope">
                        <button class="item-record-button">
                            <img src="../../assets/icon_arrow_blue.svg"/>
                        </button>
                    </template>
                </el-table-column>

                </el-table>
            </div>
        </div>

        <line-like-chat
            v-else
            :partner="detailPartner"
            :self-label="detailSelfLabel"
            :messages="detailMessages"
            @close="showDetail=false"
        />
     </div>
</template>

<script>
import server from "../ServerApi.js"
import TalkrecordDetail from "../talk/TalkrecordDetail.vue"
import constants from "@/components/constants.js";
import commonUtil from "@/components/commonutil.js";
import LineLikeChat from "./BuddycomCallTalkRecordDetail.vue"; // 追加

export default {
    data() {
        return {
            notSupportAgent: false,
            talkrecords: [],
            showDetail: false,
            detailShownRecord: null,
            languageList: null,
            selectedLanguageIndex: 0,
            timer: null,
            loading: false,
            displayInitialNotice: true,
            lastClickedRecord: null,
        };
    },
    methods: {
        initTalkRecordListPanel: function() {
            this.currentPlayingButton = null;
            this.languageList = commonUtil.getLanguageIndexList(this.$i18n.locale);
            this.selectedLanguageIndex = this.languageIndex;
            this.displayInitialNotice = true;
        },
        getList: function(refresh) {

            if (this.selected.length === 0) {
                this.talkrecords = [];
                return;
            }

            if (!this.isTalkgroup && this.selected.length !== 2) {
                this.talkrecords = [];
                return;
            }

            let self = this;

            let localFromTime = this.startTime.split(':')
            let localToTime = this.endTime.split(':')
            let localFromDate = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate(), localFromTime[0], localFromTime[1]);
            let localToDate = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate(), localToTime[0], localToTime[1]);

            let utcFromDateStr = localFromDate.toISOString();
            let utcToDateStr = localToDate.toISOString();

            let endpoint;
            let input;

            this.loading = true;
            this.displayInitialNotice = false;

            endpoint = '/getbuddycomcalltalkrecords';
            input = {
                    talkgroupId: this.selected[0].data.id,
                    fromDate: utcFromDateStr,
                    toDate: utcToDateStr,
                    interestLanguageIndex: this.selectedLanguageIndex
                }

            server.post(endpoint, input)
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            this.talkrecords = this.mergeTalkrecords(res.data.buddycomCallRecords);
                            self.setTimer();
                            break;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            this.talkrecords = [];
                            commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_refresh_talk_list"));
                            self.loading = false;
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getList").replace("{code}",res.data.status));
                            self.loading = false;
                            return;
                    }
                    if (refresh) {
                        commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_refresh_talk_list"));
                    }
                })
                .catch( function ( error ) {
                    self.loading = false;
                    commonUtil.putExceptionErrorMessage(self, "getList", error);
                });
        },
         // 行クリックで発話を取りに行く
        onRowClick(row) {
            if (!row || this.loading) return;
            this.lastClickedRecord = row;
            this.fetchUtterancesAndOpen(row);
        },

        // クリック行から発話を取得→LINEビューへ遷移
        fetchUtterancesAndOpen(talkrecord) {
            const endpoint = '/getbuddycomcallutterance';
            const input = { requestId: talkrecord.requestId };

            this.loading = true;
            this.lastClickedRecord = talkrecord; // 相手名などに使う

            server.post(endpoint, input)
            .then((res) => {
                if (res.data.status === constants.STATUS_SUCCESS) {
                    // 取得した utterances 配列を保存
                    // TODO: 現在親機は日本語のみ対応なので、ハードコードで日本語でフィルタ（子機が日本語以外の場合、その日本語への翻訳結果のみ表示）
                    // 親機を多言語対応する際に修正する
                    if (res.data.buddycomCallUtterances) {
                        this.detailShownRecord = res.data.buddycomCallUtterances.filter(utterance => utterance.languageIndex === 1);
                    } else {
                        this.detailShownRecord = [];
                    }
                    // LINE 画面へ切り替え
                    this.showDetail = true;
                } else if (res.data.status === constants.STATUS_ERROR_OBJECT_NOT_FOUND) {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"info_no_talk_record_list"));
                } else {
                    commonUtil.notifyMessage(this,"Error",
                        commonUtil.getMessageText(this.$i18n,"error_server_api")
                        .replace("{functionName}","fetchUtterancesAndOpen")
                        .replace("{code}",res.data.status)
                    );
                }
            })
            .catch((error) => {
                commonUtil.putExceptionErrorMessage(this, "fetchUtterancesAndOpen", error);
            })
            .finally(() => {
                this.loading = false;
            });
        },
        refreshList: function() {
            return this.getList(false);
        },
        mergeTalkrecords(buddycomCallRecords) {
            const mergedBuddycomCallRecords = [];

            if (!Array.isArray(buddycomCallRecords) || buddycomCallRecords.length === 0) {
                return mergedBuddycomCallRecords;
            }

            for (let i = 0; i < buddycomCallRecords.length; i++) {
                const r = buddycomCallRecords[i];

                // activateTime が存在しない( null / undefined / '' )ものはスキップ
                if (!r.activateTime) {
                    continue;
                }

                mergedBuddycomCallRecords.push({
                id: r.id,
                requestId: r.requestId,
                createTime: r.createTime ? new Date(r.createTime) : null,
                activateTime: r.activateTime ? new Date(r.activateTime) : null,
                endTime: r.endTime ? new Date(r.endTime) : null,
                requesterDisplayName: r.requesterDisplayName,
                requesterLanguage: r.requesterLanguage,
                responderDisplayName: r.responderDisplayName,
                responderLanguage: r.responderLanguage,
                });
            }

            return mergedBuddycomCallRecords;
        },
        getEmptyTalkRecordText() {
            if (this.displayInitialNotice) {
                return " ";
            } if ((this.selected === null) || (this.selected.length === 0)) {
                return commonUtil.getMessageText(this.$i18n,"info_please_select_group");
            } else {
                if (this.isTalkgroup) {
                    return commonUtil.getMessageText(this.$i18n,"info_group_talk_not_found");
                } else {
                    if (this.selected.length < 2) {
                        return commonUtil.getMessageText(this.$i18n,"info_please_select_talkers");
                    } else {
                        return commonUtil.getMessageText(this.$i18n,"info_individual_talk_not_found");
                    }
                }
            }
        },
        checkHiddenData({row}){
            if (row.hidden){
                return 'hiddenData-row';
            }else{
                return 'showData-row';
            }
        },
        isVideo(type, data) {
            return commonUtil.isVideo(type, data);
        },
        isImage(type, data) {
            return commonUtil.isImage(type, data);
        },
        getDisplayDatetime(utcTime) {
            commonUtil.getFormattedLocalDatetime(utcTime);
        },
        closeLoadingScreen() {
            if (this.loadingScreen != null) {
                this.loadingScreen.close();
                this.loadingScreen = null;
            }
        },
        checkTalkRecordList() {
            console.log(this.$refs.talkRecordsTable.data.length)
            if (this.$refs.talkRecordsTable.data.length === this.talkrecords.length) {
                clearInterval(this.timer);
                this.timer = null;
                this.loading = false;
                commonUtil.notifyMessage(this,"Success",commonUtil.getMessageText(this.$i18n,"info_refresh_talk_list"));
            }
        },
        setTimer: function() {
            if (this.timer != null) {
                clearInterval(this.timer);
                this.timer = null;
            }
            this.timer = setInterval(this.checkTalkRecordList, 100);
        },
        convertMillsec: function(duration) {
            return commonUtil.convertMillsec(duration);
        },
        getDisplayName(row) {
            return row.requesterDisplayName || row.responderDisplayName || '';
        },
        getResponderDisplayName(row) {
            return row.responderDisplayName || row.requesterDisplayName || '';
        },
        getStartDate(row) {
            if (row && (row.activateTime || row.createTime)) {
                return new Date(row.activateTime || row.createTime);
            }
            return null;
        },
        getDurationMs(row) {
            const start = this.getStartDate(row);
            const end = row && row.endTime ? new Date(row.endTime) : null;
            if (start && end) return end - start;
            return null;
        },
        sortByDisplayName(a, b) {
            const da = this.getDisplayName(a).toLowerCase();
            const db = this.getDisplayName(b).toLowerCase();
            if (da < db) return -1;
            if (da > db) return 1;
            return 0;
        }
    },
    watch: {
        date: {
            handler() {
                return this.getList(false);
            }
        },
        startTime: {
            handler() {
                return this.getList(false);
            }
        },
        endTime: {
            handler() {
                return this.getList(false);
            }
        },
        selected: {
            handler() {
                return this.getList(false);
            }
        },
        languageIndex: {
            handler(newVal) {
               this.selectedLanguageIndex = newVal;
               return this.getList(false);
            }
        },
        '$route' (to) {
            if (to.name === "Call") {
                this.initTalkRecordListPanel();
            }
        }
    },
    computed: {
        // 相手情報（一覧でクリックした行から名前などを拝借）
        detailPartner() {
            const r = this.lastClickedRecord || {};
            const name = this.getDisplayName ? this.getDisplayName(r) : (r.requesterDisplayName || r.responderDisplayName || '相手');
            return {
            name,
            status: ''
            };
        },
        // 自分情報（一覧でクリックした行から名前などを拝借）
        detailSelfLabel() {
            const r = this.lastClickedRecord || {};
            // 自分側に表示したい名前だけ返す
            return this.getResponderDisplayName(r)
        },
        // utterances → LineLikeChat の messages 形式に変換
        detailMessages() {
            const arr = Array.isArray(this.detailShownRecord) ? this.detailShownRecord : [];

            // 1) 自分の userId が取れるなら厳密判定（例: this.appData.userId）
            const myUserId =
            (this.appData && this.appData.userId != null) ? this.appData.userId :
            (this.$store && this.$store.state && this.$store.state.user && this.$store.state.user.id != null) ? this.$store.state.user.id :
            null;

            if (myUserId != null) {
                return arr.map((u, i) => ({
                    id: i + 1,
                    from: u.userId === myUserId ? 'me' : 'other',
                    text: u.text || '',
                    at: u.startTime ? new Date(u.startTime) : (u.endTime ? new Date(u.endTime) : new Date()),
                }));
            }

            // 2) 自分の userId が無い場合のフォールバック（先に出てきた2人を other/me に割当）
            const roleByUser = new Map();
            let first = null, second = null;
            for (const u of arr) {
                if (u && u.userId != null && !roleByUser.has(u.userId)) {
                    if (first == null) { first = u.userId; roleByUser.set(u.userId, 'other'); }
                    else if (second == null) { second = u.userId; roleByUser.set(u.userId, 'me'); }
                    else { roleByUser.set(u.userId, 'other'); } // 3人目以降は other 扱い（必要に応じて調整）
                }
            }

            return arr.map((u, i) => ({
                id: i + 1,
                from: roleByUser.get(u.userId) || 'other',
                text: u.text || '',
                at: u.startTime ? new Date(u.startTime) : (u.endTime ? new Date(u.endTime) : new Date()),
            }));
        }
    },
    created () {
        this.currentPlayingButton = null;
        let userAgent = window.navigator.userAgent.toLowerCase();
        if ((userAgent.indexOf('msie') > 0 ) || (userAgent.indexOf('trident') > 0 )) {
            this.notSupportAgent = true;
        }
        this.languageList = commonUtil.getLanguageIndexList(this.$i18n.locale);
        this.selectedLanguageIndex = this.languageIndex;
    },
    mounted() {
        // Ensure initial load when the tab/content is first rendered
        this.initTalkRecordListPanel();
        this.getList(false);
    },
    components: {
        LineLikeChat,
        TalkrecordDetail
    },
    props: [ 'appData', 'date', 'startTime', 'endTime', 'languageIndex', 'selected', 'isTalkgroup' ]
}

</script>

<style>
tr.talkrecord-header > th {
    color: #848991;
    font-size: 12px;
    background-color: #f6f6f6;
    padding-top: 0px;
    padding-bottom: 0px;
}
tr.hiddenData-row {
    background: #cfcfcf;
}
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: unset;
}
tr.hiddenData-row {
    background: #dddddd;
}
tr.hiddenData-row:hover {
    background-color: #cfcfcf;
}
tr.showData-row {
    background: #ffffff;
}
tr.showData-row:hover {
    background-color: #ecf1fa;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.buddycomcall-record-list-root {
    height: 100%;
    min-height: 0;
    min-width: 0;
}

.buddycomcall-record-list-panel {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    min-width: 0;
}

.buddycomcall-table-wrap {
    flex: 1;
    min-height: 0;
    min-width: 0;
    padding-bottom: 14px;
    box-sizing: border-box;
}

.buddycomcall-table-wrap >>> .el-table {
    height: 100% !important;
}

table {
    border-collapse: collapse;
}
tr.talk-record {
    border-bottom: 1px solid #eee;
}
tr.talk-record {
    border-bottom: solid;
    border-width: 1px;
    border-color: #eee;
    padding-left: 20px;
}
td.record-starttime {
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
}
td.record-displayname {
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
}
td.record-data {
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
}
.object-titlebox-right >>> .el-select .el-input {
    font-size: 12px;
    width: 130px;
}
.object-titlebox-right >>> .el-input__inner {
    height: 30px;
}
.object-titlebox-right >>> .el-input__icon {
    line-height: 30px;
}
.el-table:before {
    background-color: #ffffff;
}
.el-table >>> .cell {
    word-break: normal;
}
</style>
